import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';
import { RecentSalesTrackingLabel } from './RecentSalesLink.types';

export const trackClick = (label: RecentSalesTrackingLabel) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: label
    });
};
